import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportItemsOnHireByDate {
    loading: boolean;
    errors: any;
    branchOptions: GenericListItem[];
    customerOptions: GenericListItem[];
    reportDate: string;
    branchId: number;
    customerId: number;
}

interface GenericListItem {
    id: number;
    name: string;
}

export class ReportItemsOnHireByDateData extends React.Component<RouteComponentProps<{}>, ReportItemsOnHireByDate> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: {},
            branchOptions: [],
            customerOptions: [],
            reportDate: "",
            branchId: -1,
            customerId: -1
        } 
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //get dropdowns
                axios.get('api/Job/GetAllBranches', {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ branchOptions: res.data });
                    this.getCustomers(token ?? "", user.sub);
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    getCustomers = async (token: string, subId: string) => {
        axios.get('api/Customer/GetCustomersForDropdown?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ customerOptions: res.data, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = "";
        this.setState(change);
    }

    validate = () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.reportDate) {
            formIsValid = false;
            errors["reportDate"] = "Date is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        if (this.validate()) {
            this.runRpt();
        }
    }
 
    async runRpt() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        axios('api/Report/RunItemsOnHireByDateReport?subId=' + user.sub + '&reportDate=' + this.state.reportDate + '&branchId=' + this.state.branchId + '&CustomerId=' + this.state.customerId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Items On Hire By Date.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <div>
                    <h1>Items On Hire / Scheduled By Date Report</h1>
                    <div>This report will show all jobs installed on site or scheduled to to be installed on site up until and including the date selected</div>
                    <div>It will exclude any jobs that will be fully picked up until and including the date selected</div>
                </div>
                <div>
                    <label className="input-group" htmlFor="reportDate">
                        <span className="label">Date</span>
                        <input type='date' id="reportDate" name="reportDate" className='input' value={this.state.reportDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["reportDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["reportDate"]}</span>

                    <label className="input-group" htmlFor="branchId">
                        <span className="label">Branch</span>
                        <select className="select" id="branchId" name="branchId" value={this.state.branchId} onChange={(e) => this.handleChange(e)}>
                            <option defaultValue="-1" value="-1"></option>
                            {this.state.branchOptions.map(branch =>
                                <option key={branch.id} value={branch.id}>{branch.name}</option>
                            )};
                        </select>
                    </label>

                    <label className="input-group" htmlFor="customerId">
                        <span className="label">Customer</span>
                        <select className="select" id="customerId" name="customerId" value={this.state.customerId} onChange={(e) => this.handleChange(e)}>
                            <option defaultValue="-1" value="-1"></option>
                            {this.state.customerOptions.map(cust =>
                                <option key={cust.id} value={cust.id}>{cust.name}</option>
                            )};
                        </select>
                    </label>
                </div>
                <div>
                    <button className="defaultbutton marginLeftLabel" type='button' onClick={this.runReport}>Run Report</button>
                </div>
            </div>
        );

    }

};